<script lang="ts">
	interface Props {
		children?: import('svelte').Snippet
		small?: boolean
	}

	let { children, small = false }: Props = $props()
</script>

<span
	class="bg-primary-500 flex {small
		? 'h-4 w-4'
		: 'h-5 w-5'} items-center justify-center rounded-full text-xs text-white"
>
	{@render children?.()}
</span>
